import { ORM } from "./CouchORM";
import {db} from "../Database.svelte";

export default class TemplateTemplate extends ORM {
    static collectionType = "Template";

    static async getTemplateByName(name) {
        let results = await db.find({
            selector: {
                type: this.collectionType,
                name: name
            }
        });

        if (results.docs.length) {
            return results.docs[0]
        } else {
            throw new Error("Invalid Template")
        }
    }
}
